@if ((dataService.reportStatus$ | async) == ReportStatusEnum.Loading) {
  <dirt-risk-insights-loading></dirt-risk-insights-loading>
} @else {
  @let drawerDetails = dataService.drawerDetails$ | async;
  <div class="tw-mt-4 tw-flex tw-flex-col">
    <h2 class="tw-mb-6" bitTypography="h2">{{ "allApplications" | i18n }}</h2>
    <div class="tw-flex tw-gap-6">
      <button
        type="button"
        class="tw-flex-1"
        tabindex="0"
        (click)="dataService.setDrawerForOrgAtRiskMembers('allAppsOrgAtRiskMembers')"
      >
        <dirt-card
          #allAppsOrgAtRiskMembers
          class="tw-w-full"
          [ngClass]="{
            'tw-bg-primary-100': drawerDetails.invokerId === 'allAppsOrgAtRiskMembers',
          }"
          [title]="'atRiskMembers' | i18n"
          [value]="applicationSummary.totalAtRiskMemberCount"
          [maxValue]="applicationSummary.totalMemberCount"
        >
        </dirt-card>
      </button>
      <button
        type="button"
        class="tw-flex-1"
        tabindex="0"
        (click)="dataService.setDrawerForOrgAtRiskApps('allAppsOrgAtRiskApplications')"
      >
        <dirt-card
          #allAppsOrgAtRiskApplications
          class="tw-w-full"
          [ngClass]="{
            'tw-bg-primary-100': drawerDetails.invokerId === 'allAppsOrgAtRiskApplications',
          }"
          [title]="'atRiskApplications' | i18n"
          [value]="applicationSummary.totalAtRiskApplicationCount"
          [maxValue]="applicationSummary.totalApplicationCount"
        >
        </dirt-card>
      </button>
    </div>
    <div class="tw-flex tw-mt-8 tw-mb-4 tw-gap-4">
      <bit-search
        [placeholder]="'searchApps' | i18n"
        class="tw-grow"
        [formControl]="searchControl"
      ></bit-search>
      <button
        type="button"
        [buttonType]="'primary'"
        bitButton
        [disabled]="!selectedUrls.size"
        [loading]="markingAsCritical"
        (click)="markAppsAsCritical()"
      >
        <i class="bwi tw-mr-2" [ngClass]="selectedUrls.size ? 'bwi-star-f' : 'bwi-star'"></i>
        {{ "markAppAsCritical" | i18n }}
      </button>
    </div>

    <app-table-row-scrollable
      [dataSource]="dataSource"
      [showRowCheckBox]="true"
      [showRowMenuForCriticalApps]="false"
      [selectedUrls]="selectedUrls"
      [openApplication]="drawerDetails.invokerId || ''"
      [checkboxChange]="onCheckboxChange"
      [showAppAtRiskMembers]="showAppAtRiskMembers"
    ></app-table-row-scrollable>
  </div>
}
